import component from './components/contractmanagement';

export default {
  component
};
